module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    staticClass: "modal modal-team",
    on: {
      "click": function($event) {
        _vm.$emit('close')
      }
    }
  }, [_c('div', {
    staticClass: "modal__content modal-team__content"
  }, [_c('iframe', {
    attrs: {
      "src": _vm.content.team.video_link,
      "frameborder": "0"
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bcc71ac2"}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/modal/team/modal-team.pug
// module id = 533
// module chunks = 1